import React, { Component } from 'react';

class PoweredSpeakers extends Component {
  render() {
    return (
      <div className='col-12 section-space--top--30'>
        <div className='service-grid-item service-grid-item--style2'>
          {/* <div className='service-grid-item__image'> ## image above box
            <div className='service-grid-item__image-wrapper'>
              <img src={`/assets/img/service/serviceShort.jpg`} className='img-fluid' alt='Service Grid' />
            </div>
          </div> */}
          <div name='Powered Speakers' className='service-grid-item__content'>
            <h3 className='title'>
              <img width={50} alt={'icon'} style={{ paddingRight: '10px' }} src='/assets/img/icons/speaker.png' />
              Powered Speakers
            </h3>
            <p className='subtitle'>
              Need some sound? SL has a variety of powered speakers and subwoofers for rent. Our speakers and subs are great for a multitude of events & shows and offer great
              sound quality. With multiple speakers and subs in stock, your setup can be configurable for a wide range of uses and venues.
            </p>
            {/* <a
              href={`${process.env.PUBLIC_URL}/contact-us`}
              className='ht-btn--default ht-btn--default--dark-hovers'
            >
              CONTACT US
            </a> */}
          </div>
        </div>
      </div>
    );
  }
}

export default PoweredSpeakers;
